// src/pages/PaymentManagement/PaymentManagement.js
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import PaymentList from './PaymentList';
import RevenueStats from './RevenueStats';
import './PaymentManagement.scss';

const PaymentManagement = ({ activeView = 'payment-list' }) => {
    const { t } = useLanguage();

    const renderActiveView = () => {
        switch (activeView) {
            case 'payment-list':
                return <PaymentList />;
            case 'revenue-stats':
                return <RevenueStats />;
            default:
                return <PaymentList />;
        }
    };

    return (
        <div className="payment-management-container">
            {renderActiveView()}
        </div>
    );
};

export default PaymentManagement;